import MUIAvatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";
import useTheme from "@mui/material/styles/useTheme";

import ChangePhoto from "./change-photo.component";
import ExpandAndChangePhoto from "./expand-and-change-photo.component";

interface AvatarProps {
  fullName: string;
  imgSrc: string;
  sx?: SxProps;
  expandPhoto?: boolean;
  onChangePhoto?: () => void;
  onExpandPhoto?: () => void;
  imgSize?: number;
}

export default function Avatar({
  fullName,
  imgSrc,
  sx,
  expandPhoto,
  onChangePhoto,
  onExpandPhoto,
  imgSize = 134
}: AvatarProps) {
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        ...sx
      }}
    >
      <MUIAvatar
        alt={fullName}
        src={imgSrc}
        variant="circular"
        sx={{ width: imgSize, height: imgSize }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          width: imgSize,
          height: imgSize,
          borderRadius: "50%",
          backgroundColor: palette.avatar.bgcolor,
          opacity: 0,
          "&:hover": {
            opacity: 1
          }
        }}
      >
        {onChangePhoto && expandPhoto ? (
          <ExpandAndChangePhoto
            onExpandPhoto={onExpandPhoto}
            onChangePhoto={onChangePhoto}
          />
        ) : (
          <ChangePhoto onChangePhoto={onChangePhoto} />
        )}
      </Box>
    </Box>
  );
}
